module.exports = __webpack_public_path__ + "img/menu1.0053220b.png";